/**
 * @file InteractionTarget component: "this entity answers to a key press".
 *
 * Marking an entity with it takes it out of the automatic pickup vacuum and
 * hands it to {@link ../systems/InteractionSystem.js}, which shows the prompt
 * and runs the action. The component is pure data: it says which glyph to draw
 * and what to call the thing, never what pressing it does.
 */

import { Component } from '../ecs/Component.js';

export class InteractionTarget extends Component {
  /**
   * @param {string} label Name shown next to the prompt, e.g. the weapon name.
   * @param {string} [prompt] Key glyph drawn above the entity.
   */
  constructor(label = '', prompt = 'E') {
    super();
    /** @type {string} */
    this.label = label;
    /** @type {string} */
    this.prompt = prompt;
  }
}
